import { checkComplexity, checkPassword } from '../../lib/utils/web/accounts/password-rules';
import { checkUsername } from '../../lib/utils/web/accounts/username-rules';
import { FieldError } from './field-error';

const passwordField = document.getElementById('password') as HTMLInputElement;
const passwordInvalidLabel = document.getElementById('invalid-password') as HTMLElement;
const togglePasswordVisibilityBtn = document.getElementById('toggle-password-visibility') as HTMLButtonElement | null;
const passwordEyeIcon = document.getElementById('password-eye-icon') as SVGElement | null;
const passwordEyeOffIcon = document.getElementById('password-eye-off-icon') as SVGElement | null;

const emailField = document.getElementById('email') as HTMLInputElement;
const emailInvalidLabel = document.getElementById('invalid-email') as HTMLElement;

const agreeTosCheckBox = document.getElementById('agree-tos') as HTMLInputElement;

const submitBtn = document.getElementById('form-submit');

const errors = new FieldError();

// Update the submit button state based on current validations
function updateSubmitBtn(): void {
  if (errors.isEmpty() && emailField.value.length > 0 && passwordField.value.length > 0 && agreeTosCheckBox.checked) {
    submitBtn?.classList.remove('btn-disabled');
  } else {
    submitBtn?.classList.add('btn-disabled');
  }
}

agreeTosCheckBox.addEventListener('change', (_) => {
  updateSubmitBtn();
});

emailField.addEventListener('input', (_) => {
  const usernameFailures = checkUsername(emailField.value);
  if (usernameFailures.length > 0) {
    const formattedErrors = usernameFailures.join('<br>');
    errors.set('invalid-email', emailField, emailInvalidLabel, formattedErrors);
  } else {
    errors.remove('invalid-email', emailField, emailInvalidLabel);
  }
  updateSubmitBtn();
});

// Validate password complexity on input
passwordField.addEventListener('input', (_) => {
  const complexityFailures = checkPassword(passwordField.value);
  if (complexityFailures.length > 0) {
    const formattedErrors = complexityFailures.join('<br>');
    errors.set('password-complexity-failure', passwordField, passwordInvalidLabel, formattedErrors);
  } else {
    errors.remove('password-complexity-failure', passwordField, passwordInvalidLabel);
  }
  updateSubmitBtn();
});

// Toggle password visibility
togglePasswordVisibilityBtn?.addEventListener('click', () => {
  if (!passwordField) return;
  const isHidden = passwordField.type === 'password';
  passwordField.type = isHidden ? 'text' : 'password';

  if (passwordEyeIcon && passwordEyeOffIcon) {
    if (isHidden) {
      passwordEyeIcon.classList.add('hidden');
      passwordEyeOffIcon.classList.remove('hidden');
      togglePasswordVisibilityBtn.setAttribute('aria-label', 'Hide password');
    } else {
      passwordEyeIcon.classList.remove('hidden');
      passwordEyeOffIcon.classList.add('hidden');
      togglePasswordVisibilityBtn.setAttribute('aria-label', 'Show password');
    }
  }
});

// set initial state for terms checkbox
agreeTosCheckBox.checked = false;
